import { render, staticRenderFns } from "./flyOldmanList.vue?vue&type=template&id=a60a2af8&scoped=true"
import script from "./flyOldmanList.vue?vue&type=script&lang=js"
export * from "./flyOldmanList.vue?vue&type=script&lang=js"
import style0 from "./flyOldmanList.vue?vue&type=style&index=0&id=a60a2af8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60a2af8",
  null
  
)

export default component.exports